import React from 'react'
import { X, MoreVertical } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface DrawerHeaderProps {
  title: string
  onClose: () => void
  showCloseButton?: boolean
  actions?: React.ReactNode
  className?: string
}

export function DrawerHeader({
  title,
  onClose,
  showCloseButton = true,
  actions,
  className,
}: DrawerHeaderProps) {
  return (
    <div className={cn(
      "flex items-center justify-between px-6 py-4 border-b border-border",
      "bg-card",
      className
    )}>
      <h2 className="text-lg font-semibold" id={`drawer-title-${title}`}>
        {title}
      </h2>
      
      <div className="flex items-center gap-2">
        {actions && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <MoreVertical className="h-4 w-4" />
                <span className="sr-only">More options</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              {actions}
            </DropdownMenuContent>
          </DropdownMenu>
        )}
        
        {showCloseButton && (
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 hover:bg-transparent hover:[&>svg]:stroke-[2.5] transition-all"
            onClick={onClose}
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </Button>
        )}
      </div>
    </div>
  )
}